export const MAX_DISPLAY_TRANSPORT_ACCESSIBILITY_ONBOARDING_COUNT = 3;
export const TRANSPORT_ACCESSIBILITY_ONBOARDING_COOKIE_KEY = 'transport-accessibility_onboarding_counter';

export const DISTANCE_CALCULATING_ENABLED_CONFIG_KEY = 'distance-calculating.enabled';
